<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1 />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import NpsmAddMain from '@/views/DevelopManagement/NpsmManage/TabChild/NpsmAddMain';
export default {
  name: 'NpsmAdd',
  components: {
    childTab1: NpsmAddMain
  },
  data() {
    return {
      activeName: 'first'
    };
  }
};
</script>

<style scoped></style>
